import { SiteType } from './SiteType';

export default SiteType;
